import { render } from "./HeroiconsOutlineLogin.vue?vue&type=template&id=50e0f786"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLogin.vue"]])

export default __exports__